const createImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", reject);
    image.src = src;
  });

const getRadianAngle = (degreeValue) => (degreeValue * Math.PI) / 180;

const rotateSize = (width, height, rotation) => {
  const rotRad = getRadianAngle(rotation);

  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
  };
};

export const createCroppedImageFile = async ({
  imageSrc,
  cropPixels,
  fileName,
  mimeType,
  rotation = 0
}) => {
  const image = await createImage(imageSrc);
  const rotatedCanvas = document.createElement("canvas");
  const rotatedContext = rotatedCanvas.getContext("2d");
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const safeMimeType = mimeType && mimeType.startsWith("image/")
    ? mimeType
    : "image/jpeg";
  const rotationSize = rotateSize(image.width, image.height, rotation);

  rotatedCanvas.width = rotationSize.width;
  rotatedCanvas.height = rotationSize.height;

  rotatedContext.translate(rotationSize.width / 2, rotationSize.height / 2);
  rotatedContext.rotate(getRadianAngle(rotation));
  rotatedContext.drawImage(image, -image.width / 2, -image.height / 2);

  canvas.width = cropPixels.width;
  canvas.height = cropPixels.height;

  context.drawImage(
    rotatedCanvas,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    cropPixels.width,
    cropPixels.height
  );

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((generatedBlob) => {
      if (!generatedBlob) {
        reject(new Error("Não foi possível gerar o recorte da imagem."));
        return;
      }
      resolve(generatedBlob);
    }, safeMimeType, safeMimeType === "image/png" ? undefined : 0.92);
  });

  const file = new File([blob], fileName, {
    type: safeMimeType,
    lastModified: Date.now()
  });

  return {
    file,
    previewUrl: URL.createObjectURL(blob)
  };
};
